<template>
  <v-container fluid grid-list-md>
    <!-- This layout below is for the information fields. -->
    <v-layout row wrap style="margin-top: 25em; margin-bottom: 25em;">
      <v-flex d-flex xs8>
        <v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import OperationalScreen_BaseQuadrant from "./OperationalScreen/OperationalScreen_BaseQuadrant";
  import OperationalScreen_QuadrantToolbar from "./OperationalScreen/OperationalScreen_QuadrantToolbar";
  // console.log(moment().format('DD-MM-YYYY'));

  export default {
    name: 'test',
    extends: OperationalScreen_BaseQuadrant,
    props: {
      boxConfig: {}
      //eventId: String
      // objId: String
    },
    computed: {

    },
    components: {
      OperationalScreen_QuadrantToolbar
    },
    data: () => ({
      lorem: `Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.`,
      dateStartCB: new Date().toISOString().substr(0, 10),
      dateEndCB: new Date().toISOString().substr(0, 10),
      dateStartBD: new Date().toISOString().substr(0, 10),
      dateEndBD: new Date().toISOString().substr(0, 10),
      bookingTime: null,
      BlockedDates: [],
      dialogBD: false,
      dialogCB: true,
      name: '',
      email: '',
      phoneNumber: '',
      cbTime: '',
      today: moment().format('YYYY-MM-DD'),
      type: 'month',
      now: null,
      overLap: false,
      events: [
        {
          start_date: '14-09-2020',
          end_date: '21-09-2020',
          StartTime: '09:00',
          EndTime: '12:00',
          OrderId: 'GR54X21',
          UserName: 'Bob',
          Email: 'bob@bobdebouwer.nl',
          Phone: '0624232120',
          Source: 'AirBnB',
          locationId: 'L.ABC.000',
        },
        {
          start_date: '23-09-2020',
          end_date: '25-09-2020',
          StartTime: '00:00',
          EndTime: '23:59',
          OrderId: 'BLOCKED',
          UserName: '',
          Email: '',
          Phone: '',
          Source: 'BLOCKED',
          locationId: 'L.ABC.000',
        },
        {
          start_date: '28-09-2020',
          end_date: '28-09-2020',
          StartTime: '',
          EndTime: '',
          OrderId: 'YT04EW1S',
          UserName: 'Henk',
          Email: 'henk@ouwehenkie.nl',
          Phone: '0624235423',
          Source: '',
          locationId: 'L.ABC.000',
        },
      ],
      outputArray: [],
      BLOCKED: [],
    }),
    computed: {
      // convert the list of events into a map of lists keyed by date
      eventsMap() {
        const map = {};
        this.outputArray.forEach((e) => (map[e.date] = map[e.date] || []).push(e));
        return map;
      },
      computedFormattedSelectDates() {
        let returnDates = [];
        this.selectDates.forEach ( e => {
          returnDates.push(e.split('-').reverse().join('-'));
        });
        return returnDates;
      },
    },
    mounted() {
      this.getProductCalendar();
    },
    methods: {
      open(event) {
        alert(event.title);
      },
      deleteEvent(event) {
      },
      nextWeek() {
        moment(this.today).date(7);
        console.log(this.today);
      },
      switchToWeek() {
        this.type = 'week';
      },
      switchToMonth() {
        this.type = 'month';
      },
      addBlockedDates() {
        this.outputArray = [];
        this.events.push({
          start_date: this.dateStart.split('-').reverse().join('-'),
          end_date: this.dateEnd.split('-').reverse().join('-'),
          StartTime: '',
          EndTime: '',
          OrderId: 'BLOCKED',
          UserName: '',
          Email: '',
          Phone: '',
          Source: 'BLOCKED',
          locationId: 'L.ABC.000',
        });

        this.dialogCB = false;
        this.dialogBD = false;
        this.getProductCalendar();
      },
      addBooking() {
        this.outputArray = [];
        console.log("Laurens this.name", this.name);
        console.log("Laurens this.cbTime", this.cbTime);
        console.log("Laurens ", this.email);
        console.log("Laurens this.phoneNumber", this.phoneNumber);

        this.events.push({
          start_date: this.dateStart.split('-').reverse().join('-'),
          end_date: this.dateEnd.split('-').reverse().join('-'),
          StartTime: this.cbTime,
          EndTime: '',
          OrderId: '',
          UserName: this.name,
          Email: this.email,
          Phone: this.phoneNumber,
          Source: '',
          locationId: 'L.ABC.000',
        });

        this.dialogCB = false;
        this.getProductCalendar();
      },
      getProductCalendar() {
        const self = this;
        this.events.forEach((arrayItem) => {
          const StartDate = moment(arrayItem.start_date, 'DD-MM-YYYY');
          const EndDate = moment(arrayItem.end_date, 'DD-MM-YYYY');
          const Days = EndDate.diff(StartDate, 'days');

          const firstObj = {
            title: arrayItem.OrderId,
            details: arrayItem.UserName,
            date: moment(StartDate).format('DD-MM-YYYY').split('-').reverse().join('-'),
            open: false,
            Source: arrayItem.Source,
            time: arrayItem.StartTime,
            duration: 45,
          };

          self.outputArray.push(firstObj);

          for (let i = 1; i < Days + 1; i++) {
            const mydate = moment(StartDate).add(i, 'day').format('DD-MM-YYYY');

            const myObj = {
              title: arrayItem.OrderId,
              details: arrayItem.UserName,
              date: mydate.split('-').reverse().join('-'),
              open: false,
              Source: arrayItem.Source,
              time: arrayItem.StartTime,
              duration: 45,
            };
            self.outputArray.push(myObj);
          }
        });

        this.outputArray.forEach((item) => {
          if (item.Source === 'BLOCKED') {
            item.color = 'darkred';
            delete item.time;
            delete item.duration;
          } else {
            item.color = '#1867c0';
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  //.all {
  //  margin-bottom: 20em;
  //}

  .quadrant {
    max-height: 300px;
    max-width: 400px;
  }

  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    &.with-time {
      position: absolute;
      right: 4px;
      margin-right: 0px;
      background-color: #1867c0;
    }
  }

  .calendar {
    position: relative;
    right: 20px;
    height: 300px;
    width: 390px;
  }

  .theme--light.v-sheet {
    background-color: #fff;
    border-color: #fff;
    color: rgba(0,0,0,.87);
    max-width: 400px;
    margin-bottom: 0em;
    max-height: 450px;
  }

  .buttons {
    position: relative;
    left: 30px;
  }

  .buttons2 {
    position: relative;
    left: 60px;
  }

  .panel {
    padding-left: 40px;
    width: 250px;
  }

  //.v-expansion-panel__container:first-child {
  //  border-top: none!important;
  //  max-height: 200px;
  //}

  .container {
    padding: 2px 20px 0px 20px !important;
  }

  .marginBottom {
    width: calc(40vh);
    height: calc(40vh);
    margin-top: 10em;
    margin-left: 10em;
    margin-bottom: 20em;
  }

  .backgroundForEventDetails {
    position: relative;
    bottom: 1.5em;
    min-height: 70em;
    min-width: 140em;
    background-color: white;
    margin-left: -3.4em;
    margin-right: -3.4em;
  }
  //
  //.v-dialog {
  //  width: 30% !important;
  //  background-color: white !important;
  //}
</style>
